import { Link } from "@tanstack/react-router"

export function SignupNotEnabledContent() {
  return (
    <div className="prose text-neutral-500">
      <h2 className="text-4xl font-bold text-neutral-800">
        Signup Not Available
      </h2>
      <p className="text-lg text-balance">
        Signup is not available at this time. Please contact support for
        assistance.
      </p>
      <p className="text-lg">
        Already have an account?{" "}
        <Link className="text-primary underline" to="/login">
          Log in
        </Link>
      </p>
    </div>
  )
}
